import type from '../commons/loginActionStatus';

const DEFAULT_STATE = {
  userInfo: null,
  authError: null,
  requestState: false,
  status: null,
  userAttributes: {},
  tenantId: null
};

export const authReducer = (state = DEFAULT_STATE, action) => {
  const actionType = action.type;
  let userInfo;
  let authError = action.error;
  let requestState = action.requestState;
  let userAttributes;
  let status = action.status;
  switch (actionType) {
    // ------Sign in -------

    case type.SIGNIN_REQUEST:
      return { ...state, requestState, status };

    case type.SIGNIN_SUCCESS:
      userInfo = action.result;
      userAttributes = action.userAttributes;
      return {
        ...state,
        userInfo,
        requestState,
        status,
        userAttributes,
      };

    case type.SIGNIN_FAILURE:
      return { ...state, authError, requestState, status };

    // verify sign in 

    case type.VERIFY_SIGNIN_REQUEST:
      return { ...state, requestState };

    case type.VERIFY_SIGNIN_SUCCESS:
      userAttributes = action.userAttributes;
      return { ...state, requestState, status, userAttributes };

    case type.VERIFY_SIGNIN_FAILURE:
      return { ...state, authError, requestState, status };

      // logout

    case type.SIGNOUT_REQUEST:
      return { ...state, requestState };

    case type.SIGNOUT_SUCCESS:
      return { ...state, requestState, status };

    case type.SIGNOUT_FAILURE:
      return { ...state, authError, requestState, status };

    // change hospital

    case type.CHANGE_HOSPITAL_REQUEST:
      return { ...state, requestState };

    case type.CHANGE_HOSPITAL_SUCCESS:
      userAttributes = action.userAttributes;
      return { ...state, requestState, status, userAttributes };

    case type.CHANGE_HOSPITAL_FAILURE:
      return { ...state, authError, requestState, status };

    default:
      return state;
  }
};
